import { useTranslation } from "react-i18next";
import { NOTE_DIRECTIONS } from "@/services/api";
import { FormButtonSelect } from "@/shared/Components/Form/FormButtonSelect";
import styles from "./styles.module.scss";

export const DirectionSelect = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <FormButtonSelect
        placeholder={t("notesPage.selectDirection")}
        name={"currentNote.direction"}
        options={[
          { label: t("notesPage.outgoing"), value: NOTE_DIRECTIONS.OUTGOING },
          { label: t("notesPage.incoming"), value: NOTE_DIRECTIONS.INCOMING },
        ]}
      />
    </div>
  );
};
